// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alarm-clock .el-dialog {\n  border-radius: 10px;\n}\n.alarm-clock .el-dialog__body .el-descriptions__header {\n  display: block;\n  text-align: center;\n}\n.alarm-clock .el-dialog__body .el-descriptions-item__content .el-icon-copy-document {\n  padding-left: 7px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
